<template>
    <v-container class="pa-0 ma-0" id="mainhomecontainer">
        <v-card>
            <v-overlay v-model="overlay"
                    color= "#FE5800" >
                    <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>

            <v-card-title class="pa-0">
                <v-container style="" class="">

                    <v-row align="center" justify="center">

                        <v-col cols="12" sm="12" md="12">


                            Edit Retail Item


                        </v-col>


                    </v-row>

                </v-container>
            </v-card-title>
            <v-card-text>
                <v-divider></v-divider>
                <v-form v-model="valid" enctype="multipart/form-data" id="editRetailItem">
                    <v-container>
                        <v-row>
                            <v-col cols="12" md="12">
                                <h4 class="title">Retail Item Information</h4>
                            </v-col>
                        </v-row>
                        <v-row align="center">
                            <v-col cols="3" md="3" class="font-weight-bold" style="font-size:18px;" >
                            {{$t('zz_separator')}}
                            </v-col>
                            <v-col cols="3" md="3">
                            <v-switch label="" v-model="data.separation" color="success"></v-switch>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="12">
                                <v-text-field
                                v-model="data.retailitemname"
                                name="retailitemname"
                                label="Title"
                                required
                                v-validate="'required|max:255'"
                                :error-messages="errors.collect('retailitemname')"
                                data-vv-name="retailitemname"
                                ></v-text-field>
                            </v-col>

                            <v-col cols="12" v-for="(tlang,ind) in translationlanguages" :key="'itmtranstitle-'+tlang">
                                <h5>{{tlang}}</h5>
                                <v-text-field
                                    v-model="languagetranslations[tlang].title"
                                    name="ttitle[tlang]"
                                    :label="$t('zz_title')"

                                ></v-text-field>
                            </v-col>
                            <v-col cols="6" md="6">
                                <v-text-field
                                v-model="data.subtitle"
                                name="subtitle"
                                label="Subtitle"
                                ></v-text-field>
                            </v-col>

                            <v-col cols="12" v-for="(tlang,ind) in translationlanguages" :key="'itmtranssubtitle-'+tlang">
                                <h5>{{tlang}}</h5>
                                <v-text-field
                                    v-model="languagetranslations[tlang].subtitle"
                                    name="tsubtitle[tlang]"
                                    :label="$t('zz_sub_title')"

                                ></v-text-field>
                            </v-col>

                            <v-col cols="6" md="6">
                                <v-text-field
                                v-model="data.productcode"
                                name="productcode"
                                label="Product Code"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="6" >
                                <v-text-field
                                v-model="categoryname"
                                name="categoryname"
                                label="Category Name"
                                >
                                </v-text-field>

                            </v-col>
                            <v-col cols="6">
                                <v-btn color="primary" tile class="ml-auto  font-weight-bold" @click="addcateggory">Add Category</v-btn>

                            </v-col>

                        </v-row>
                        <v-row v-if="data.separation==false">
                            <v-col cols="6" md="6" sm="6">
                                <v-autocomplete
                                label="Retail Category"
                                v-model="retailcategory_id"
                                name="retailcategory_id"
                                item-text="name"
                                item-value="id"
                                :items="retailcategories"
                                ></v-autocomplete>
                            </v-col>
                            <v-col cols="6" md="6" sm="6">
                                <v-text-field
                                v-model="data.brand"
                                name="brand"
                                label="Brand/Make"
                                ></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="6" md="6" sm="6">
                                <v-text-field
                                v-model="data.size"
                                name="size"
                                label="Size"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="6" md="6">
                                <v-text-field
                                v-model="price"
                                name="price"
                                label="Price (RRP)"
                                @keyup="getper"
                                required
                                v-validate="'required|max:255'"
                                :error-messages="errors.collect('price')"
                                data-vv-name="price"
                                ></v-text-field>
                            </v-col>

                            <v-col cols="6" md="6" sm="6">
                                <v-text-field
                                v-model="saleprice"
                                @keyup="getper"
                                name="saleprice"
                                label="Discounted Price"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="6" md="6" sm="6">
                                <v-text-field
                                v-model="salepricediscountpercentage"
                                name="salepricediscountpercentage"
                                label="Discount (%)"
                                @keyup="getdiscountper"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" class="spaced" v-if="!data.separation">
                                        <div class="tooltip"><img src="https://api.juzzap.com/storage/flags/es.svg" width="30px"> <span class="tooltiptext">España</span></div>
                                        <div class="tooltip"><img src="https://api.juzzap.com/storage/flags/gb.svg" width="30px"> <span class="tooltiptext">UK</span></div>
                                        <div class="tooltip"><img src="https://api.juzzap.com/storage/flags/de.svg" width="30px"> <span class="tooltiptext">Germany</span></div>
                                        <div class="tooltip"><img src="https://api.juzzap.com/storage/flags/se.svg" width="30px"> <span class="tooltiptext">Sweden</span></div>
                                        <div class="tooltip"><img src="https://api.juzzap.com/storage/flags/ru.svg" width="30px"> <span class="tooltiptext">Russia</span></div>
                                        <div class="tooltip"><img src="https://api.juzzap.com/storage/flags/fr.svg" width="30px"> <span class="tooltiptext">France</span></div>
                                        <div class="tooltip"><img src="https://api.juzzap.com/storage/flags/it.svg" width="30px"> <span class="tooltiptext">Italy</span></div>
                                        <div class="tooltip"><img src="https://api.juzzap.com/storage/flags/gr.svg" width="30px"> <span class="tooltiptext">Greece</span></div>
                                    </v-col>


                            <!-- <v-col cols="3" md="3" class="text-center ">
                              <v-btn class="primary" block large @click="translator">Add Translation</v-btn>

                            </v-col> -->

                            <v-col cols="12" md="12" v-if="!data.separation">

                                <v-textarea
                                v-model="data.description"
                                name="description"
                                label="Retail Item Description"
                                ></v-textarea>

                            </v-col>

                            <v-col cols="12" v-for="(tlang,ind) in translationlanguages" :key="'itmtransdescription-'+tlang">
                                <h5>{{tlang}}</h5>
                                <editor
                                api-key="kmqk9zj3cswmwgz5j95fcwx8fh4nutj31o7ru7va5lxht7nk"
                                initialValue=""
                                v-model="languagetranslations[tlang].description"
                                :init="editorConfigDescription"
                                ></editor>
                            </v-col>


                        </v-row>

                        <v-row>
                            <v-col cols="6" md="6" sm="6">
                                <v-text-field
                                v-model="data.extra1"
                                name="extra1"
                                label="Extra1"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="6" md="6" sm="6">
                                <v-text-field
                                v-model="data.extra2"
                                name="extra2"
                                label="Extra2"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="6" md="6" sm="6">
                                <v-text-field
                                v-model="data.extra3"
                                name="extra3"
                                label="Extra3"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="6" md="6" sm="6">
                                <v-text-field
                                v-model="data.extra4"
                                name="extra4"
                                label="Extra4"
                                ></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row v-if="!data.separation">
                            <v-col cols="12" sm="12" md="12">
                                <h3 class="title red--text">Select Retail Item Image</h3>
                            </v-col>
                        </v-row>
                        <v-row v-if="!data.separation">
                            <v-col cols="12" md="6" sm="6">

                                <Cropper classname="cropper" :src="mainimg" @change="onChangeImage" />



                                <v-row>
                                    <v-col cols="12" md="12" sm="12" align="center">
                                        <v-btn color="primary" @click="$refs.imgfile.click()">

                                            <input type="file" ref="imgfile" @change="mainim($event)" accept="image/*" class="d-none" id="mainimage"/>Upload  Image
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col col="12" md="6" sm="6">
                                <img style="max-width:100%"  :src="mainimage"  class="grey lighten-2"  max-height="300"  v-if="mainimage!=null" />
                            </v-col>
                        </v-row>

                        <v-divider></v-divider>

                        <v-row >
                            <v-col cols="12" md="12">


                                <v-card elevation="3" class="pa-3 mb-3" v-if="!data.separation">

                                    <v-row>
                                        <v-col  md="12" cols="12">
                                            <h2>Gallery Images</h2>
                                        </v-col>
                                        <v-col v-for="(item,index) in retailitemgallery" :key="index" md="3" cols="12" class="img_wrp">
                                            <img :src="item.imageurl" class="imgResponsiveMax" append-icon="mdi-close-box-outline" height="150" style="max-width: 100%;height: auto;max-height: 150px;">
                                            <v-icon class="close" @click="delelteImage(index)">mdi-close-box-outline</v-icon>
                                        </v-col>
                                    </v-row>

                                    <v-row v-for="(item, index) in galleries" :key="index">

                                        <v-col cols="12" md="11">


                                            <v-file-input
                                            accept="image/png, image/jpeg, image/bmp"
                                            placeholder="Pick an Gallery Image"
                                            prepend-icon="mdi-camera"
                                            label="Gallery Image"
                                            :id="'img'+index"
                                            :name="'imageurl['+index+']'"

                                            ></v-file-input>

                                        </v-col>

                                        <v-col cols="12" md="1" sm="1" justify="right" align="right">
                                            <v-row class="">
                                            <v-col cols="12" md="12" sm="12">
                                                <a @click="galleries.splice(index, 1)"><v-icon  style="color:red">mdi-delete</v-icon></a>
                                            </v-col>
                                            </v-row>

                                        </v-col>

                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" md="12" sm="12">
                                            <v-btn class="add " color="primary" @click="addgallery">Add Gallery</v-btn>
                                        </v-col>
                                    </v-row>

                                </v-card>
                                    <v-divider></v-divider>
                                <div class="my-3">
                                <v-btn color="primary" @click="submit">Save</v-btn>
                                </div>
                            </v-col>
                        </v-row>

                    </v-container>
                </v-form>
            </v-card-text>

            <!-- <v-dialog v-model="descriptiondialog" persistent max-width="650px">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                    color="primary"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    >
                    Open Dialog
                    </v-btn>
                </template>
                <v-card>
                    <v-card-title>
                        <span class="headline">Item Description Translation</span>
                    </v-card-title>

                    <v-form v-model="valid" enctype="multipart/form-data" id="editbusinessdesccription">

                        <div v-if="businessdescriptiondata.length>0">

                            <!-- <div v-for="(businessdescription,index) in businessdescriptiondata" :key="index">
                            <div v-for="(item, index) in itemdescription" :key="index" align="center">

                                <v-card-text>
                                    <v-container>
                                        <v-row>



                                            <v-col cols="12" sm="12">



                                                <v-autocomplete
                                                label="Select Language"
                                                v-model="item.languagecode"
                                                :name="'businessdescriptionlanguagecodearr['+index+']'"
                                                item-text="name"
                                                item-value="languagecode"
                                                :items="lang"
                                                >

                                                </v-autocomplete>




                                            </v-col>
                                            <v-col cols="12" sm="12">



                                                <v-textarea

                                                v-model="item.description"
                                                :name="'businessdescriptiontranslatorarr['+index+']'"
                                                label="Business Description"
                                                >

                                                </v-textarea>





                                            </v-col>
                                        </v-row>
                                    </v-container>

                                </v-card-text>

                            </div>
                            <v-card-text>
                                <v-row>
                                    <v-col cols="12" class="text-right">
                                        <v-btn color="primary" tile class="ml-auto  font-weight-bold" @click="addtranslator"><v-icon class="mr-5">mdi-plus</v-icon>Add New Translation</v-btn>
                                    </v-col>
                                </v-row>
                            </v-card-text>


                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="blue darken-1" text @click="backtobusiness()">Close</v-btn>
                                <v-btn color="blue darken-1" text @click="updatedescription()">Save</v-btn>
                            </v-card-actions>

                        </div>
                        <div v-else>
                                <v-card-text>
                                    <v-container>
                                        <v-row>



                                            <v-col cols="12" sm="12">

                                                <v-select
                                                v-model="businessdescriptionlanguagecode"
                                                :items="lang"
                                                label="Select Language"
                                                item-text="name"
                                                item-value="languagecode"
                                                required
                                                ></v-select>
                                            </v-col>
                                            <v-col cols="12" sm="12">

                                                <v-textarea
                                                v-model="businessdescriptiontranslator"
                                                name="businessdescriptiontranslator"
                                                label="Business Description"

                                                ></v-textarea>

                                            </v-col>
                                        </v-row>
                                    </v-container>

                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="blue darken-1" text @click="backtobusiness()">Close</v-btn>
                                    <v-btn color="blue darken-1" text @click="createdescription()">Save</v-btn>
                                </v-card-actions>
                        </div>
                    </v-form>
                </v-card>
            </v-dialog> -->
        </v-card>
        <v-footer padless fixed class="footer-1">
                <v-row class="py-2 pl-5">
                    <v-btn class="d-none d-md-flex px-3 px-2 ma-1 footer-buttons" color="#FE5800" elevation="21" large  @click="submit">{{$t('zz_save')}}</v-btn>
                    <v-btn class="d-md-none d-lg-none d-xl-none px-3 ma-1 footer-buttons" color="#FE5800" elevation="21" small  @click="submit">{{$t('zz_save')}}</v-btn>
                </v-row>
            </v-footer>
    </v-container>
</template>
<script>
import Vue from "vue";
import VeeValidate from "vee-validate";
import { Cropper } from 'vue-advanced-cropper'

import Editor from '@tinymce/tinymce-vue'


export default
{
    props:
    {
        source: String
    },
    data: () => ({

        descriptiondialog:false,
        businessdescriptiondata:[],
        businessdescriptionlanguagecode:"",
        businessdescriptionlanguagecodearr:[],
        businessdescriptiontranslatorarr:[],
        desccriptiontype:"",
        businessdescriptiontranslator:"",
        languagelist:[{name:"English",value:"en"},
                        {name:"Spanish",value:"es"},
                        {name:"French",value:"fr"},
                        {name:"German",value:"de"},
                        {name:"Russian",value:"ru"},],
        itemdescription:[{'id':'','languagecode':'','description':'','business_id':'','retailitem_id':''}],

        overlay: false,
        valid: true,
        retailitemname:"",
        description:"",
        dictionary:
        {
                    attributes: {
                        name: "Retail Item Name",
                    },
                    custom: {}
        },
        mainimage:null,
        galleries:[{'imageurl':''}],
        imageurl:'',
        business_id:0,
        id:0,
        data:[],
        retailitemgallery:[],
        retailcategories:[],
        retailcategory_id:0,
        salepricediscountpercentage:0,
        saleprice:0,
        mainimg:null,
        coordinates: {
          width: 0,
          height: 0,
          left: 0,
          top: 0
        },
        subtitle:'',
        size:'',
        price:0,
        business:[],

        lang:[],
        translationlanguages:[],
        languagetranslations:[],
        categoryname:'',
    }),
     components: {
         'editor': Editor,
            Cropper
    },
    created()
    {
        this.storeBusiness=JSON.parse(localStorage.getItem('business'));

        this.business_id=this.storeBusiness.id;

        if (this.$route.params.id) {
        this.id = this.$route.params.id;
        }



        this.$http
        .get(this.$apidomain+"businessdata/"+this.business_id)
        .then(res => {
        if(res.data.success==0)
                {
                    this.$router.push({name:'businesslistnew'});
                }
                this.business = res.data.businesses;
                this.translationlanguages=res.data.businesses.translationlanguages;

        })
        .catch(err => {
                console.log(err.response);
        });


        this.fetchdata();
        this.fetchRetailCategories();
        this.fetchLang();
        this.fetchbusinessdescription();
    },
    methods:
    {
        getper(event)
        {
            let saleprice=this.saleprice;
            let discount=0;

            if(saleprice>0 && this.price>0)
            {
                discount=(this.price-this.saleprice)/100;
            }


            this.salepricediscountpercentage=discount;

        },
        getdiscountper()
        {
            let discount=0;
            let salep=0;

            if(this.price>0)
            {
                discount=(this.price*this.salepricediscountpercentage)/100;
                salep=this.price-discount;

            }

            this.saleprice=salep;

        },
        addcateggory()
        {
            this.overlay=true;
            this.$http
            .post(this.$apidomain+"addcategory/"+ this.business_id,{ categoryname: this.categoryname })
            .then(res => {
                if(res.data.success==1)
                    {

                        // this.$router.go('/');
                        this.fetchRetailCategories();
                        this.categoryname="";
                        this.overlay=false;

                    }
                //console.log("types "+ this.types);
            })
            .catch(err => {
                console.log(err.response);
                this.overlay=false;

            });
        },
        addtranslator()
        {
        this.itemdescription.push({
            'id':'',
            'languagecode':'',
            'description':'',
            'business_id':'',
            'item_id':'',
            })
        },
        backtobusiness()
        {
            this.descriptiondialog=false;

        },
        translator()
        {
            this.descriptiondialog=true;
        },
        fetchLang()
        {
            this.$http
            .get(this.$apidomain+"languageslist")
            .then(res => {
            this.lang = res.data.languages;
            })
            .catch(err => {
            console.log(err.response);
            });
        },
        createdescription()
        {
            let th = this;
            if (this.$validator.validateAll())
            {

                let fd = new FormData(document.getElementById("editbusinessdesccription"));

                fd.append('type','update');

                fd.append('languagecode',th.businessdescriptionlanguagecode);

                fd.append('businessdescription',th.businessdescriptiontranslator);

                this.$http
                .post(this.$apidomain+"createretailitemdescription/"+ this.business_id+"/"+this.id, fd)
                .then(res => {
                if(res.data.success)
                {
                    this.descriptiondialog=false;
                    this.fetchdata();
                    this.fetchbusinessdescription();

                }
                else
                {
                    let errmsg=[];
                    for(var prop in res.data.errors){
                        errmsg.push(res.data.errors[prop][0]);
                    }
                    this.overlay=false;
                    alert(errmsg[0]);
                    this.descriptiondialog=false;


                }
                })
                .catch(err => {
                    console.log(err.response);
                    this.overlay=false;
                });
            }
        },

        updatedescription()
        {
            let th = this;
            if (this.$validator.validateAll())
            {

                let fd = new FormData(document.getElementById("editbusinessdesccription"));

                fd.append('type','update');

                fd.append('itemdescription',JSON.stringify(this.itemdescription));

                // fd.append('languagecode',th.businessdescriptionlanguagecodearr);

                // fd.append('businessdescription',th.businessdescriptiontranslatorarr);

                this.$http
                .post(this.$apidomain+"updateretailitemdescription/"+ th.business_id+"/"+th.id, fd)
                .then(res => {
                if(res.data.success)
                {
                    this.descriptiondialog=false;
                    this.fetchdata();
                    this.fetchbusinessdescription();
                }
                else
                {
                    let errmsg=[];
                    for(var prop in res.data.errors){
                        errmsg.push(res.data.errors[prop][0]);
                    }
                    this.overlay=false;
                    alert(errmsg[0]);
                    this.descriptiondialog=false;


                }
                })
                .catch(err => {
                    console.log(err.response);
                    this.overlay=false;
                });
            }
        },

        fetchbusinessdescription()
        {
            // this.overlay=true;
            this.$http
            .get(this.$apidomain+"retailitemdescriptiondata/" + this.business_id+"/"+this.id)
            .then(res => {
            if(res.data.success==1)
            {
                this.datadescription=res.data.itemdescription;

                this.businessdescriptiondata=res.data.itemdescription;

                this.itemdescription=res.data.itemdescription;



                // this.businessdescriptiondata=res.datadescription.itemdescription;

                // this.businessdescriptionlanguagecode=res.datadescription.itemdescription.languagecode;

                // this.businessdescriptiontranslator=res.datadescription.itemdescription.description;

                // this.overlay=false;


            }
            else
            {

                // this.overlay=false;




            // console.log(res.data.businesses);
            }
            })
            .catch(err => {
                console.log(err.response);
            });
        },
        fetchdata() {
             this.$http
            .get(this.$apidomain+"retailitemData/" + this.id)
            .then(res => {
            this.data=res.data.Retailitem;
            this.data.separation=this.data.separation==0?false:true;
            this.languagetranslations=res.data.Retailitem.languagetranslations;

            this.retailitemgallery=res.data.retailitemgallery;
            this.image=this.data.retailitemname;

            this.business_id=this.data.businesses_id;

            this.retailcategory_id=this.data.retailcategory_id;
            // console.log(res.data.businesses);

            this.mainimage=this.data.mainimage;

            this.price=this.data.price;
            this.saleprice=this.data.saleprice

            this.salepricediscountpercentage=this.data.salepricediscountpercentage

            })
            .catch(err => {
            console.log(err.response);
            });
        },
        fetchRetailCategories()
        {
            this.$http
            .get(this.$apidomain+"retailcategorylistpwa/"+this.business_id)
            .then(res => {
            this.retailcategories = res.data.retailcategory;
            //console.log("types "+ this.types);
            })
            .catch(err => {
            console.log(err.response);
            });
        },

        delelteImage(index)
        {
            this.$http
            .post(this.$apidomain+"retailitemdeleteimages/"+ this.id+'/'+index)
            .then(res => {
                this.retailitemgallery=res.data.retailitemgallery;
                //console.log("types "+ this.types);
            })
            .catch(err => {
                console.log(err.response);
            });
        },
        addgallery()
        {
         this.galleries.push({'imageurl':''})
        },
        onChangeImage({coordinates, canvas})
        {
            this.coordinates = coordinates

            this.mainimage = canvas.toDataURL()
        },
        mainim(event)
        {
            var input = event.target;
            // Ensure that you have a file before attempting to read it
            if (input.files && input.files[0])
            {
                // create a new FileReader to read this image and convert to base64 format
                var reader = new FileReader();
                // Define a callback function to run, when FileReader finishes its job
                reader.onload = (e) => {
                    // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
                    // Read image as base64 and set to imageData
                    this.mainimg = e.target.result;
                }
                // Start the reader job - read file as a data url (base64 format)
                reader.readAsDataURL(input.files[0]);
            }
        },
        dataURLtoFile(dataurl, filename)
        {

            var arr = dataurl.split(','),
                  mime = arr[0].match(/:(.*?);/)[1],
                  bstr = atob(arr[1]),
                  n = bstr.length,
                  u8arr = new Uint8Array(n);

            while(n--){
                  u8arr[n] = bstr.charCodeAt(n);
            }

            return new File([u8arr], filename, {type:mime});
        },
        submit()
        {
            let th = this;
            if (this.$validator.validateAll())
            {
            let fd = new FormData(document.getElementById("editRetailItem"));

            fd.append('businesses_id',this.business_id);
            if(this.mainimg!=null)
                {
                    fd.append('mainimage',this.dataURLtoFile(this.mainimage,document.getElementById('mainimage').files[0].name));
                }
            fd.append('retailcategory_id',this.retailcategory_id);

            fd.append('languagetranslations',JSON.stringify(this.languagetranslations));


            if(this.data.separation)
            {
                fd.append('separation',1);

            }
            else
            {
                fd.append('separation',0);
            }

            this.$http
            .post(this.$apidomain+"editRetailItem/"+this.id, fd)
            .then(res => {
            if(res.data.success)
            {
                this.$router.push({name:'retailitemlist'});

            }
            else
            {
                    let errmsg=[];
                    for(var prop in res.data.errors){
                        errmsg.push(res.data.errors[prop][0]);
                    }
                    // alert(errmsg[0]);
                    this.overlay=false;
            }
            })
                .catch(err => {
                console.log(err.response);
                this.overlay=false;
                });

            }
        }
    }
}
</script>
